var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurePayment = function SvgSecurePayment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#secure-payment_svg__a)",
    stroke: "#161616"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.72 40.142c-.46.188-.97.188-1.43 0-9.72-3.98-14.78-13.871-14.78-24.949V8.358c0-.914.56-1.722 1.39-1.995l13.49-4.578c.4-.137.83-.137 1.23 0l13.5 4.567c.83.284 1.39 1.092 1.39 1.995v6.836c0 11.067-5.06 20.968-14.78 24.948l-.01.01Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.75 18.375h8.49c1.24 0 2.25 1.06 2.25 2.363v4.588c0 1.963-1.51 3.549-3.38 3.549h-6.24c-1.87 0-3.38-1.585-3.38-3.549v-4.588c0-1.302 1.01-2.363 2.25-2.363h.01ZM21 11.025c1.93 0 3.5 1.649 3.5 3.675v3.434c0 .125-.1.241-.23.241h-6.55a.239.239 0 0 1-.23-.241V14.7c0-2.026 1.57-3.675 3.5-3.675H21Z",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.5 23.625 2 2.1 4-4.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "secure-payment_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h42v42H0z"
  })))));
};
export default SvgSecurePayment;